import type {
  ContentCardData,
  ContentUploadWindow,
} from "../../@types/portalAluno";


export const UPLOAD_WINDOW_OPTIONS: Array<{
  value: ContentUploadWindow;
  label: string;
}> = [
  { label: "Última hora", value: "last-hour" },
  { label: "Hoje", value: "today" },
  { label: "Esta semana", value: "this-week" },
  { label: "Este mês", value: "this-month" },
  { label: "Este ano", value: "this-year" },
];

const getWindowStart = (
  uploadWindow: ContentUploadWindow,
  reference: Date
): Date => {
  const start = new Date(reference);

  if (uploadWindow === "last-hour") {
    start.setHours(start.getHours() - 1);
    return start;
  }

  start.setHours(0, 0, 0, 0);

  if (uploadWindow === "today") return start;

  if (uploadWindow === "this-week") {
    start.setDate(start.getDate() - start.getDay());
    return start;
  }

  if (uploadWindow === "this-month") {
    start.setDate(1);
    return start;
  }

  start.setMonth(0, 1);
  return start;
};

export const isWithinUploadWindow = (
  publishedAtIso: string | undefined,
  uploadWindow: ContentUploadWindow,
  reference: Date = new Date()
) => {
  if (!publishedAtIso) return false;

  const publishedAt = new Date(publishedAtIso);

  if (Number.isNaN(publishedAt.getTime())) return false;

  return publishedAt.getTime() >= getWindowStart(uploadWindow, reference).getTime();
};

export const filterCardsByUploadWindow = (
  cards: ContentCardData[],
  uploadWindow: ContentUploadWindow | null,
  reference?: Date
) =>
  uploadWindow
    ? cards.filter((card) =>
        isWithinUploadWindow(card.publishedAtIso, uploadWindow, reference)
      )
    : cards;
